<div class="atlas-table">
  <p-table [showGridlines]="true" [value]="searchResult?.Result" [paginator]="true" [rows]="searchParams ? searchParams.PageSize : 20"
    [lazy]="true" [totalRecords]="searchResult?.TotalCount" [loading]="loading" (onLazyLoad)="lazyLoad($event)">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>
          <span class="block">{{ 'profiles.relationships.main' | translate | ucfirst }}</span>
          <span>{{ 'profiles.relationships.contact' | translate }}</span>
        </th>
        <th>
          <span class="block">{{ 'profiles.relationships.billing' | translate | ucfirst }}</span>
          <span>{{ 'profiles.relationships.contact' | translate }}</span>
        </th>
        <th>
          {{ 'profiles.relationships.editor' | translate | ucfirst }}
        </th>
        <th>
          <span class="block">{{ 'profiles.relationships.receives' | translate | ucfirst }}</span>
          <span>{{ 'profiles.relationships.communication' | translate }}</span>
        </th>
        <th pSortableColumn="ReportName">
          {{ 'common.name' | translate | ucfirst }}
          <p-sortIcon field="ReportName"></p-sortIcon>
        </th>
        <th pSortableColumn="Title">
          {{ 'profiles.relationships.title-label' | translate | ucfirst }}
          <p-sortIcon field="Title"></p-sortIcon>
        </th>
        <th pSortableColumn="Email">
          {{ 'profiles.relationships.email' | translate | ucfirst }}
          <p-sortIcon field="Email"></p-sortIcon>
        </th>
        <th pSortableColumn="WorkPhone">
          {{ 'profiles.relationships.phone' | translate | ucfirst }}
          <p-sortIcon field="WorkPhone"></p-sortIcon>
        </th>
        <th pSortableColumn="InvRelationType">
          {{ 'profiles.relationships.relationship-type' | translate | ucfirst }}
          <p-sortIcon field="InvRelationType"></p-sortIcon>
        </th>
        <th [style]="{ width: '120px' }"></th>
      </tr>
      <tr>
        <th>
          <p-select [options]="booleanOptions" placeholder="{{ 'common.filter' | translate | titlecase }}"
            styleClass="p-column-filter" [(ngModel)]="searchParams.MainContact" (onChange)="filterChanged()" showClear
            appendTo="body"></p-select>
        </th>
        <th>
          <p-select [options]="booleanOptions" placeholder="{{ 'common.filter' | translate | titlecase }}"
            styleClass="p-column-filter" [(ngModel)]="searchParams.BillingContact" (onChange)="filterChanged()"
            showClear appendTo="body"></p-select>
        </th>
        <th>
          <p-select [options]="booleanOptions" placeholder="{{ 'common.filter' | translate | titlecase }}"
            styleClass="p-column-filter" [(ngModel)]="searchParams.IsEditor" (onChange)="filterChanged()" showClear
            appendTo="body"></p-select>
        </th>
        <th>
          <p-select [options]="booleanOptions" placeholder="{{ 'common.filter' | translate | titlecase }}"
            styleClass="p-column-filter" [(ngModel)]="searchParams.ReceivesCommunication" (onChange)="filterChanged()"
            showClear appendTo="body"></p-select>
        </th>
        <th>
          <input pInputText placeholder="{{ 'profiles.relationships.filter-by-name' | translate | ucfirst }}"
            styleClass="p-column-filter" [(ngModel)]="searchParams.ReportName" (input)="filterChanged()" />
        </th>
        <th>
          <input pInputText placeholder="{{ 'profiles.relationships.filter-by-title' | translate | ucfirst }}"
            styleClass="p-column-filter" [(ngModel)]="searchParams.Title" (input)="filterChanged()" />
        </th>
        <th>
          <input pInputText placeholder="{{ 'profiles.relationships.filter-by-email' | translate | ucfirst }}"
            styleClass="p-column-filter" [(ngModel)]="searchParams.Email" (input)="filterChanged()" />
        </th>
        <th>
          <input pInputText placeholder="{{ 'profiles.relationships.filter-by-phone' | translate | ucfirst }}"
            styleClass="p-column-filter" [(ngModel)]="searchParams.WorkPhone" (input)="filterChanged()" />
        </th>
        <th>
          <p-select [options]="relationTypeOptions"
            placeholder="{{ 'profiles.relationships.filter-by-type' | translate | titlecase }}"
            styleClass="p-column-filter" [(ngModel)]="searchParams.InvRelationType" (onChange)="filterChanged()"
            showClear appendTo="body"></p-select>
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-relation>
      <tr>
        <td>
          <p-checkbox [disabled]="relatedProfileAccess < 2" [binary]="true" [(ngModel)]="relation.MainContact"
            (onChange)="mainContactToggled(relation)"></p-checkbox>
        </td>
        <td>
          <p-checkbox [disabled]="relatedProfileAccess < 2" [binary]="true" [(ngModel)]="relation.BillingContact"
            (onChange)="billingContactToggled(relation)"></p-checkbox>
        </td>
        <td>
          <p-checkbox [disabled]="relatedProfileAccess < 2" [binary]="true" [(ngModel)]="relation.IsEditor"
            (onChange)="isEditorToggled(relation)"></p-checkbox>
        </td>
        <td>
          <p-checkbox [disabled]="relatedProfileAccess < 2" [binary]="true" [(ngModel)]="relation.ReceivesCommunication"
            (onChange)="receivesCommunicationToggled(relation)"></p-checkbox>
        </td>
        <td>
          <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-10">
            <!-- <span class="p-column-title">{{ 'common.name' | translate | ucfirst }}</span> -->
            <wl-profile-type-icon [isMember]="relation.Member" [isOrg]="relation.OrgInd"
              [profileId]="relation.RelProfileID" [memberTypeIconColor]="relation.MemberTypeIconColor"
              [styleOverrides]="{ 'max-width': '20px', 'max-height': '20px' }"></wl-profile-type-icon>
            <a [ngClass]="{ 'f-wb': relation.MainContact }" [routerLink]="['/profile', relation.RelProfileID]">{{
              relation.ReportName }}</a>
          </div>
        </td>
        <td>
          <span [ngClass]="{ 'f-wb': relation.MainContact }">{{ relation.Title ? relation.Title : relation.ProfileTitle
            }}</span>
        </td>
        <td>
          <a *ngIf="relation.Email" href="mailto:{{ relation.Email }}">{{ relation.Email }}</a>
        </td>
        <td>
          {{ relation?.DisplayPhone | phone }}
        </td>
        <td>
          {{ relation.InvRelationType }}
        </td>
        <td>
          <p-menu #actions appendTo="body" [popup]="true" [model]="actionItemsForRelation(relation)"></p-menu>
          <button pButton type="button" icon="pi pi-caret-down" iconPos="right" (click)="actions.toggle($event)">
            {{ 'common.actions' | translate | uppercase }}
          </button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-progressSpinner *ngIf="loading"></p-progressSpinner>
  <wl-page-size-dropdown [(pageSize)]="searchParams.PageSize" [pageSizes]="[20, 100, 0]"
    (pageSizeChange)="pageSizeChanged()"></wl-page-size-dropdown>
</div>